import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../../Svg';

const FilterButton = props => (
    <div className="ui-btn ui-btn_primary sales__filterBtn" onClick={() => props.onButtonClick()}>
        <span>
            <Svg size="Medium" iconName="filter" />
        </span>
        {props.children}
    </div>
);

FilterButton.propTypes = {
    children: PropTypes.string,
    onButtonClick: PropTypes.func
};

export default FilterButton;



// WEBPACK FOOTER //
// ./src/js/modules/Filter/components/FilterButton.js